import { useRef, useState } from 'react';

export const usePage = (size = 100) => {
	const [currentPage, setCurrentPage] = useState(0);
	const pageCount = useRef(0);

	const handlePage = (page, count) => {
		setCurrentPage(page);
		if (count) pageCount.current = count;
	};

	return {
		currentPage,
		handlePage,
		pageSize: size,
		pageCount: pageCount.current,
	};
};
